'use client'

import { useTranslate } from '@tolgee/react'
import {
  Collapsible,
  CollapsibleContent,
  XIcon,
} from 'oddle-shop-monorepo.design-system'
import React from 'react'
import { useSelector } from 'react-redux'

import { P } from '@/components/common/Typo'
import { selectDetailMenuSite, selectMenuMode } from '@/redux/meta/selector'
import { selectStoreOrder } from '@/redux/order/selector'
import { isObjectEmpty } from '@/utils/object'

interface CloseButtonProps {
  onClick: () => void
  className?: string
}

const CloseButton = ({ onClick, className }: CloseButtonProps): JSX.Element => (
  <button
    data-testid="button.close"
    className={`absolute right-2 top-2 cursor-pointer rounded-md bg-yellow-100 p-1 transition-colors hover:bg-yellow-200 ${
      className || ''
    }`}
    onClick={onClick}
  >
    <XIcon className="h-4 w-4 text-black" />
  </button>
)

const AnnouncementBar = (): JSX.Element | null => {
  const { t } = useTranslate()
  const orderState = useSelector(selectStoreOrder)
  const detailMenu = useSelector(selectDetailMenuSite)
  const menuMode = useSelector(selectMenuMode)
  const [visible, setVisible] = React.useState(true)
  const today = new Date().getTime()

  const onClick = React.useCallback(() => setVisible(false), [])

  if (
    menuMode === 'live' &&
    (isObjectEmpty(detailMenu?.announcementBar) ||
      (orderState?.data?.taxAndCharges?.length || 0) === 0)
  ) {
    return null
  }

  if (
    menuMode === 'live' &&
    detailMenu?.announcementBar &&
    (detailMenu.announcementBar.startDateTime * 1000 > today ||
      today > detailMenu.announcementBar.endDateTime * 1000)
  ) {
    return null
  }

  if (menuMode === 'live') {
    return null
  }

  return (
    <Collapsible open={visible}>
      <CollapsibleContent>
        <div className="relative w-full rounded-md border border-yellow-300 bg-yellow-100 p-4">
          <P className="mr-2 text-black">
            {menuMode === 'preview'
              ? t(
                  "Your Oddle Shop is in preview mode, so you won't be able to receive orders until you complete your billing account setup."
                )
              : t(detailMenu?.announcementBar?.content || '')}
          </P>
          <CloseButton onClick={onClick} />
        </div>
      </CollapsibleContent>
    </Collapsible>
  )
}

export default AnnouncementBar
